"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetWidget = exports.fetchInstallationWidgetSuccess = exports.receiveInstallationWidget = exports.fetchWidgetsByWidgetIds = void 0;
const widget_api_1 = require("../../../../../../modules/widget/api/widget_api");
const player_1 = require("../../../../../../modules/shared/player");
const redux_batched_actions_1 = require("redux-batched-actions");
const store_1 = require("../../../../../../exports/store");
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
const fetchWidgetsByWidgetIds = (widgetIds, successCb) => {
    return (dispatch, getState) => {
        // dispatch(setWidgetPanelLoading(true));
        const state = getState();
        const linkId = store_1.Selectors.getLinkId(state);
        (0, widget_api_1.readInstallationWidgets)(widgetIds, linkId).then(res => {
            return Promise.resolve({ responseBody: res.data, dispatch, getState });
        }).catch(e => {
            // dispatch(setWidgetPanelLoading(false));
            player_1.Player.doTrigger(player_1.Events.app_error_logger, {
                error: new Error(`widgetMap request error ${widgetIds.join(',')}`),
                metaData: { widgetIds: widgetIds.join(',') },
            });
            throw e;
        }).then(props => {
            (0, exports.fetchInstallationWidgetSuccess)(props);
            successCb === null || successCb === void 0 ? void 0 : successCb(props);
        }, e => {
            console.error('fetchWidgetsByWidgetIds error', e);
        });
    };
};
exports.fetchWidgetsByWidgetIds = fetchWidgetsByWidgetIds;
const receiveInstallationWidget = (widgetId, widget) => {
    return {
        type: action_constants_1.RECEIVE_INSTALLATIONS_WIDGET,
        payload: widget,
        widgetId: widgetId,
    };
};
exports.receiveInstallationWidget = receiveInstallationWidget;
const fetchInstallationWidgetSuccess = ({ responseBody, dispatch }) => {
    const { data, success } = responseBody;
    // dispatch(setWidgetPanelLoading(false));
    if (success) {
        const _batchActions = [];
        for (const v of data) {
            _batchActions.push((0, exports.receiveInstallationWidget)(v.id, v));
        }
        dispatch((0, redux_batched_actions_1.batchActions)(_batchActions));
    }
    else {
        player_1.Player.doTrigger(player_1.Events.app_error_logger, {
            error: new Error('widgetMap error'),
            metaData: {},
        });
    }
};
exports.fetchInstallationWidgetSuccess = fetchInstallationWidgetSuccess;
const resetWidget = (widgetIds) => {
    return {
        type: action_constants_1.RESET_WIDGET,
        payload: widgetIds,
    };
};
exports.resetWidget = resetWidget;
//# sourceMappingURL=widget.js.map